import React, { useEffect, useState } from "react";
import moment from "moment";
import { useParams, useSearchParams, Link } from "react-router-dom";

import {NotificationFilterListAPI} from "./../../API/Team/NotificationAPI";
//import Sidebar from "./Common/Sidebar";
//import Header from "./Common/Header";
//import Loader from "./../Loader";
import Paginate from "./../../utils/Pagination";
import Layout from "./Layout";
import ContentLoader from "../../utils/ContentLoader";
//import "./../../../Public/css/leads_list.css";
import { Offcanvas } from 'react-bootstrap';
import ReactSelect from 'react-select';
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";


const NotificationFilterDataList = () =>{

    const {filtertype} = useParams();
    const [searchParam] = useSearchParams();

    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(false);
    const [btnloader, setBtnLoader] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    const [callers, setCallers] = useState([]);
    //const [callername, setCallerName] = useState("");
    //const [leadids, setLeadIDs] = useState([]);
    //const [isleadassign, setIsLeadAssign] = useState(false);
    const [programs, setPrograms] = useState([]);
    const [institute, setInstitute] = useState([]);
    const [selectedcallervalues, setSelectedCallerValues] = useState([]);
    const [selectedcaller, setSelectedCaller] = useState([]);
    const [filtercaller, setFilterCaller] = useState("");
    const [filterprogram, setFilterProgram] = useState("");
    const [filterinstitute, setFilterInstitute] = useState("");
    const [filtersStored, setFiltersStored] = useState(null);
    const [isleadfiltermodal, setIsLeadFilterModal] = useState(false);
    const [followupstartdate, setFollowupStartDate] = useState(null);
    const [followupenddate, setFollowupEndDate] = useState(null);

    const [filtersDraft, setFiltersDraft] = useState({ 
                                                        filterprogram: [],
                                                        filterinstitute: [],
                                                        filtercaller: "",
                                                        filterfollowupstartdate: "",
                                                        filterfollowupenddate: ""
                                                    });
    
    const perpagedata = 15;

    //const params = new URLSearchParams();


    {/*useEffect(() => {

        if(searchParam !== "" && searchParam !== null)
        {
            if(searchParam.get('filter_campaignid') !== "" && searchParam.get('filter_campaignid') !== null)
            {
                filterparams.append('filter_campaignid', searchParam.get('filter_campaignid'));
            }

            if(searchParam.get('filter_callerid') !== "" && searchParam.get('filter_callerid') !== null)
            {
                filterparams.append('filter_callerid', searchParam.get('filter_callerid'));
            }

            if(searchParam.get('filter_startdate') !== "" && searchParam.get('filter_startdate') !== null)
            {
                filterparams.append('filter_startdate', searchParam.get('filter_startdate'));
            }

            if(searchParam.get('filter_enddate') !== "" && searchParam.get('filter_enddate') !== null)
            {
                filterparams.append('filter_enddate', searchParam.get('filter_enddate'));
            }

            if(currentPage)
            {
                filterparams.append('page', currentPage);
            }

            if(perpagedata)
            {
                filterparams.append('per_page', perpagedata);
            }
        }

        NotificationFilterListAPI(setNotifications, setLoading, currentPage, perpagedata, setPageCount, filtertype, filterparams);

        //console.log('>>>>'+usersList);

    }, [currentPage]);*/}

    useEffect(() => {
            
        console.log("Step 1");

        /*if (!filtersStored)
        {
            console.log('Step 1.2');
            return;  
        }*/ 
                
        console.log("Step 2");
        const params = new URLSearchParams();
        
        
        if (filtersStored)
        {
            console.log("Step 3");
                
            Object.keys(filtersStored).forEach(key => {
                if (filtersStored[key]) {
                    params.append(key, filtersStored[key]);
                }
            });
        }

        console.log("Step 4");

        params.append("page", currentPage);
        params.append("per_page", perpagedata);
        console.log(">>>>>" + JSON.stringify(params));
        //LeadDataAPI(setLeads, setLoading, setShowLeads, currentPage, perpagedata, setPageCount, setStages, setPrograms, setInstitutes, setCallers, params, false, setTotalRecords, setSources);

        //LeadFilterDataAPI(setLeads, setLoading, currentPage, perpagedata, setPageCount, filtertype, setIsLeadAssign, params, setInstitute, setPrograms, setCallers);
        NotificationFilterListAPI(setNotifications, setLoading, currentPage, perpagedata, setPageCount, filtertype, setPrograms, setInstitute, setCallers, params);

    }, [filtersStored, currentPage]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }

    const handleCallerName = (selcaller) =>{
        console.log('>>>' + JSON.stringify(selcaller));

        setSelectedCaller(selcaller);
        
        if(selcaller)
        {
            let callervalue = selcaller ? selcaller.value : "";

            setFiltersDraft(prev => ({
                            ...prev,
                            filtercaller: callervalue
                        }));

            //setSelectedCallerValues(callervalue);

            //setSelectedCaller(selcaller);
        }
    }

    const handleFilterProgram = (selprogram) =>{

        setFilterProgram(selprogram);

        let programvalue = selprogram ? selprogram.value : "";

        setFiltersDraft(prev => ({
                            ...prev,
                            filterprogram: programvalue
                        }));


    }

    const handleFilterInstitute = (selinstitute) =>{

        setFilterInstitute(selinstitute);

        let institutevalue = selinstitute ? selinstitute.value : "";

        setFiltersDraft(prev => ({
                            ...prev,
                            filterinstitute: institutevalue
                        }));
    }

    const handleFilterCaller = (selcaller) =>{
        console.log(selcaller);
        setFilterCaller(selcaller);

        let callervalue = selcaller ? selcaller.value : "";

        setFiltersDraft(prev => ({
                            ...prev,
                            filtercaller: callervalue
                        }));
    }

    const handleLeadFilterModal = () =>{
        setIsLeadFilterModal(!isleadfiltermodal);
    }

    const handleLeadFilterModalHide = () =>{
        setIsLeadFilterModal(false);
    }

    const handleResetFilter = (e) =>{
        
        setFilterProgram("");
        setFilterInstitute("");
        setFilterCaller("");
        setFollowupStartDate("");
        setFollowupEndDate("");
        
        setFiltersDraft({
                    filterprogram: "",
                    filterinstitute: "",
                    filtercaller: "",
                    filterfollowupstartdate: "",
                    filterfollowupenddate: ""
        });

        setFiltersStored(null);
        setCurrentPage(1);        

        NotificationFilterListAPI(setNotifications, setLoading, currentPage, perpagedata, setPageCount, filtertype, setPrograms, setInstitute, setCallers, "");
    }

    const handleApplyFilter = () =>{        

        console.log('i am here');
        setFiltersStored({
                            ...filtersDraft,
                            //page: 1
                        });

        setCurrentPage(1);

        setIsLeadFilterModal(false);
    }
    
    const handleFollwupDateRange = (follodates) => {

        console.log('>>>>' + follodates);
        
        const [followstartdate, followenddate] = follodates;

        setFollowupStartDate(followstartdate);
        setFollowupEndDate(followenddate);

        setFiltersDraft(prev => ({
                            ...prev,
                            filterfollowupstartdate: followstartdate ? format(followstartdate, "yyyy-MM-dd") : "",
                            filterfollowupenddate: followenddate ? format(followenddate, "yyyy-MM-dd") : ""
                        }));

    }



    return(
    <Layout>
        <div className="content">

            <div className="row">
                <div className="col-md-12">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-8">
                                {filtertype === 'today' ?
                                    <h4 className="page-title">Follow Up for Today</h4>
                                :
                                    (filtertype === 'pending' ?
                                        <h4 className="page-title">Pending Follow Ups</h4>
                                    :
                                        <h4 className="page-title">Follow Up</h4>
                                    )
                                }

                            </div>
                            <div className="col-4 text-end">
                                <div className="head-icons">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="right">
                        <div className="row crm-filter-row-top align-items-center">

                            <div className="col-md-6 mb-1 d-flex align-items-center">
                                <button className="btn btn-success me-2" onClick={handleLeadFilterModal}>
                                    <i className="ti ti-filter me-2"></i> Filter
                                </button>

                                <button type="button" className="btn btn-dark" onClick={handleResetFilter}>
                                    <i className="fa fa-undo me-2"></i>Clear Filter
                                </button>
                            </div>
                            
                        </div>

                        <Offcanvas show={isleadfiltermodal} onHide={handleLeadFilterModalHide} placement="end" className="offcanvas-custom">
                            <Offcanvas.Header closeButton>
                                <Offcanvas.Title id="contained-modal-title-vcenter">Filter Leads</Offcanvas.Title>
                            </Offcanvas.Header>
                            <Offcanvas.Body>
                                <div class="row crm-filter-row-bottom align-items-end">
                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Program</label>
                                        <ReactSelect className="" value={filterprogram} onChange={handleFilterProgram} options={programs} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Program"></ReactSelect>

                                    </div>

                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Institute</label>
                                        <ReactSelect className="" value={filterinstitute} onChange={handleFilterInstitute} options={institute} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Institute"></ReactSelect>

                                    </div>

                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Caller</label>                                        
                                        <ReactSelect className="" value={filtercaller} onChange={handleFilterCaller} options={callers} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Caller"></ReactSelect>
                                    </div>

                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Follow Up Date</label>
                                        <DatePicker  className="form-control" selected={followupstartdate} onChange={ handleFollwupDateRange } startDate={followupstartdate} endDate={followupenddate} selectsRange isClearable placeholderText="Select followup date range" />

                                    </div>
                                    
                                </div>                                

                                <div class="crm-filter-actions">
                                    <button type="button" class="btn btn-cancel" data-bs-dismiss="modal" onClick={handleLeadFilterModalHide}>Close</button>

                                    <button type="button" className="btn btn-primary me-2" onClick={handleApplyFilter}>
                                            <i className="ti ti-search me-2"></i>Apply Filter
                                    </button>

                                </div>
                            </Offcanvas.Body>
                        </Offcanvas>
                    </div>
                </div>
                
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">

                            <div className="table-responsive table-wrapper">
                                {loading ?
                                    <ContentLoader />
                                :
                                <table className="table table-data-section" id="faqlist">
                                    <thead className="thead-light">
                                        <tr>
                                            <th>Lead Name</th>
                                            <th>Contact</th>
                                            <th>Program</th>
                                            <th>Institute</th>
                                            <th>Caller</th>
                                            <th>Schedule Date & Time</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                    {
                                    notifications && notifications.length > 0  ?
                                        notifications.map(notification =>
                                        (

                                            <tr key={notification.id}>
                                                <td>
                                                    <Link to={`/team/lead-profile/${notification.id}`}>{notification.name}</Link>
                                                </td>
                                                <td>{notification.contact}</td>
                                                <td>{notification.program}</td>
                                                <td>{notification.institute}</td>
                                                <td>{notification.callername}</td>
                                                <td>{moment(notification.display_date).format('DD-MM-YYYY')} {notification.display_time}</td>

                                            </tr>
                                        ))
                                    :
                                        <tr>
                                            <td colSpan="6">
                                                <center>No record found...</center>
                                            </td>
                                        </tr>
                                    }

                                    </tbody>
                                </table>
                                }
                            </div>
                        </div>
                    </div>

                    {pagecount > 1 ?
                    <div className="row pagination-section">

                        <nav>
                            <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                        </nav>
                    </div>
                    :
                        <></>
                    }

                </div>

            </div>
        </div>
    </Layout>
    )
}

export default NotificationFilterDataList;
